module.exports = __webpack_public_path__ + "static/media/loseLarge0_1.65bed1e6.png";